import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-show-subscriber-receipt-ledger-print',
  templateUrl: './show-subscriber-receipt-ledger-print.component.html',
  styleUrls: ['./show-subscriber-receipt-ledger-print.component.scss'],
})
export class ShowSubscriberReceiptLedgerPrintComponent implements OnInit {
  data = [];
  total_amt;
  total_discount;
  constructor(
    private dialogref: MatDialogRef<ShowSubscriberReceiptLedgerPrintComponent>,
    @Inject(MAT_DIALOG_DATA) public res: any
  ) { }

  ngOnInit(): void {
    // this.data = this.res['val'];
    // console.log(this.data);



    //Receipt Number Show In Ascending Order
    this.data = this.res['val'].sort((a, b) => {
      const getLastNumber = (rcpt: string) => {
        const parts = rcpt?.split('/');
        return parts && parts.length ? Number(parts[parts.length - 1]) : 0;
      };

      return getLastNumber(a.rcpt_no) - getLastNumber(b.rcpt_no);
    });

    // Login Financial Year
    const selectedYear = sessionStorage.getItem('selectedYear') || '';

    const years = selectedYear.match(/\d{4}/g);

    let loginFY = '';

    if (years && years.length >= 2) {
      loginFY = `${years[0].slice(-2)}-${years[1].slice(-2)}`;
    }

    // Set period dates based on Receipt FY and Login FY
    this.data.forEach(item => {

      if (item.new_Subscription_Type) {

        // Example rcpt_no = SVV11/25-26/215
        const parts = item.rcpt_no ? item.rcpt_no.split('/') : [];
        const receiptFY = parts.length >= 2 ? parts[1] : '';

        if (receiptFY === loginFY) {
          item.display_sub_from_date = item.sub_perid_from_date;
          item.display_sub_to_date = item.sub_perid_to_date;
        } else {
          item.display_sub_from_date = item.sub_perid_from_date1;
          item.display_sub_to_date = item.sub_perid_to_date1;
        }

      } else {

        // Old logic
        item.display_sub_from_date = item.sub_perid_from_date;
        item.display_sub_to_date = item.sub_perid_to_date;
      }

    });

    this.calculateTotal();
  }

  calculateTotal() {
    this.total_amt = 0;
    this.total_discount = 0;
    for (let index = 0; index < Object.keys(this.data).length; index++) {
      this.total_amt += parseFloat(this.data[index]['total_amt']);
      this.total_discount += parseFloat(this.data[index]['discount']);
    }
  }

  formatAmount(value: any): string {
    if (value == null) return '';
    const num = Number(value);
    // जर decimal नसेल तर integer परत करा
    if (num % 1 === 0) {
      return num.toFixed(0);  // 1000.00 → "1000"
    }
    return num.toString();     // 1000.75 → "1000.75"
  }


  exportExcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


  show = false

  //   printPage() {
  //   this.show = true;
  //   const printContent = document.getElementById('print-section')?.outerHTML;
  //   if (!printContent) {
  //     console.error("Print section not found!");
  //     return;
  //   }

  //   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  //   if (printWindow) {
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Print Report</title>
  //           <style>
  //             @media print {
  //               @page {
  //                 size: A3 landscape;
  //                 margin: 5mm;
  //               }
  //               html, body {
  //                 margin: 0;
  //                 padding: 0;
  //                 font-family: Arial, sans-serif;
  //                 font-size: 15px;
  //                 line-height: 1.2;
  //                 overflow: hidden;
  //               }
  //               table {
  //                 width: 100%;
  //                 border-collapse: collapse;
  //                 table-layout: fixed;
  //               }
  //               tr {
  //                 page-break-inside: avoid;
  //                 break-inside: avoid;
  //               }
  //               th, td {
  //                 padding: 1px;
  //                 border: 1px solid black;
  //                 text-align: center;
  //                 font-size: 14px;
  //                 line-height: 1.2;
  //                 box-sizing: border-box;
  //               }
  //               /* Always hide Action column in print */
  //               th:last-child,
  //               td:last-child {
  //                 display: none !important;
  //               }
  //               .noPrint {
  //                 display: none !important;
  //               }
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           <div id="print-section">
  //             ${printContent}
  //           </div>
  //           <script>
  //             window.onload = function() {
  //               window.print();
  //               setTimeout(() => { window.close(); }, 500);
  //             };
  //           </script>
  //         </body>
  //       </html>
  //     `);
  //     printWindow.document.close();
  //   } else {
  //     console.error("Failed to open print window.");
  //   }
  // }


  // printPage() {
  //   this.show = true;
  //   const printContent = document.getElementById('print-section')?.outerHTML;
  //   if (!printContent) {
  //     console.error("Print section not found!");
  //     return;
  //   }

  //   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  //   if (printWindow) {
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Print Report</title>
  //           <style>
  //             @media print {
  //               @page { 
  //                 size: A3 landscape;
  //                 margin: 5mm;
  //               }
  //               body { 
  //                 font-family: Arial, sans-serif;
  //                 font-size: 15px;
  //                 margin: 0;
  //                 padding: 5mm;
  //                 line-height: 1.2;
  //               }
  //               table { 
  //                 width: 100%;
  //                 border-collapse: collapse;
  //                 page-break-inside: avoid;
  //               }
  //               th, td { 
  //                 padding: 2px;
  //                 border: 1px solid black;
  //                 text-align: center;
  //                 font-size: 12px;
  //                 line-height: 1.2;
  //               }
  //               .noPrint { display: none; }

  //               /* ---------------------------------- */
  //               /* 🅰 OPTION A – Auto-scaling (uncomment to use) */
  //               /* body {
  //                 transform: scale(0.9);      /* adjust 0.8–1.0 as needed */
  //                 transform-origin: top left;
  //               } */

  //               /* ---------------------------------- */
  //               /* 🅱 OPTION B – Dynamic column shrink (default) */
  //               table { table-layout: auto; }
  //               th, td { 
  //                 max-width: 120px;          /* adjust max column width */
  //                 white-space: normal;       /* allow wrapping */
  //                 word-wrap: break-word;
  //                 overflow-wrap: break-word;
  //               }
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           <div id="print-section">
  //             ${printContent}
  //           </div>
  //           <script>
  //             window.onload = function() { 
  //               window.print(); 
  //               setTimeout(() => { window.close(); }, 500);
  //             };
  //           </script>
  //         </body>
  //       </html>
  //     `);
  //     printWindow.document.close();
  //   } else {
  //     console.error("Failed to open print window.");
  //   }
  // }


  printPage() {
    this.show = true;
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page { 
                size: A3 landscape;
                margin: 5mm;
              }
              body { 
                font-family: Arial, sans-serif;
                font-size: 14px;
                margin: 0;
                padding: 5mm;
                line-height: 1.2;
              }
              table { 
                width: 100%;
                border-collapse: collapse;
                table-layout: auto;          /* 🔑 allow natural width per column */
              }
              th, td { 
                padding: 4px 6px;
                border: 1px solid black;
                text-align: center;
                font-size: 12px;
                line-height: 1.2;
                white-space: nowrap;         /* 🔑 keep all content in one line */
              }
              th { 
                font-weight: bold;
              }
              .noPrint { display: none; }

              /* 🔑 Auto-fit adjustment: shrink columns dynamically */
              th, td {
                max-width: 250px;            /* prevent overly wide columns */
                overflow: hidden;
                text-overflow: ellipsis;     /* cut off if still too long */
              }
            }
          </style>
        </head>
        <body>
          <div id="print-section">
            ${printContent}
          </div>
          <script>
            window.onload = function() { 
              window.print(); 
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}
